import { useState } from "react";
import { Close, TipsAndUpdates } from "@mui/icons-material";
import { CardHeader, IconButton, Typography } from "@mui/material";

import analytics from "fond/analytics";
import localStorage from "fond/utils/localStorage";

import { TipCard, TipCardContent, TipTitle } from "./SidebarTips.styles";

const STORAGE_KEY = "FOND_SIDEBAR_TIPS_HIDDEN";

export const SidebarTips: React.FC = () => {
  const initialTipsHiddenState = localStorage.getItem(STORAGE_KEY) === "true";
  const [isTipHidden, setIsTipHidden] = useState<boolean>(initialTipsHiddenState);

  const onCloseTips = () => {
    // TODO: once we have settled on how to manage the tips, we will use the User Preferences API to store this setting
    localStorage.setItem(STORAGE_KEY, "true");
    setIsTipHidden(true);
    analytics.track("sidebar.tips.closed");
  };

  if (isTipHidden) {
    return null;
  }
  return (
    <TipCard variant="outlined">
      <CardHeader
        action={
          <IconButton aria-label="Dismiss this tip" onClick={onCloseTips} sx={{ fontSize: (theme) => theme.typography.size.normal }}>
            <Close fontSize="inherit" />
          </IconButton>
        }
        title={
          <TipTitle>
            Tip <TipsAndUpdates fontSize="inherit" sx={{ color: (theme) => theme.palette.biarri.secondary.activeGrey }} />
          </TipTitle>
        }
      />
      <TipCardContent sx={{ pt: 0, pb: 1 }}>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Star your most important projects by selecting the star icon on a project.
        </Typography>
      </TipCardContent>
    </TipCard>
  );
};
